import { PageHeader } from "features/MarketingMaterials/pages/components/PageHeader/PageHeader.tsx";
import { CheckoutContainer } from "features/MarketingMaterials/pages/Checkout/Checkout.styles.ts";
import { ReviewCartPageContent } from "features/MarketingMaterials/pages/Checkout/ReviewCartPage.styles.ts";
import { ReviewCartDetails } from "features/MarketingMaterials/pages/Checkout/components/ReviewCartDetails/ReviewCartDetails.tsx";
import useMarketingMaterialsCart from "features/MarketingMaterials/hooks/useMarketingMaterialsCart.ts";
import {
	ConfirmationNumber,
	ThankYouHeader
} from "features/MarketingMaterials/pages/Checkout/CartConfirmationPage.styles.ts";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store.tsx";
import { Divider } from "@mui/material";

export const CartConfirmationPage = () => {
	const { confirmedItems, cartData } = useMarketingMaterialsCart();
	const confirmationNumber = useSelector((state: RootState) => state.marketingMaterialsCart.confirmationNumber);
	return (
		<>
			<PageHeader cartData={cartData} />
			<CheckoutContainer>
				<ThankYouHeader>
					<h3>Thank You!</h3>
					<ConfirmationNumber>
						<h5>Your order has been received!</h5>
						<h5>Your confirmation number is {confirmationNumber}.</h5>
					</ConfirmationNumber>
					<h5>
						Your order will appear on the My Orders page in a few minutes. In the meantime, you can{" "}
						<a href="/marketing-materials">continue shopping</a> and place more orders.
					</h5>
				</ThankYouHeader>
				<Divider />
				<ReviewCartPageContent>
					<ReviewCartDetails
						isConfirmationPage
						cartItems={confirmedItems}
					/>
				</ReviewCartPageContent>
			</CheckoutContainer>
		</>
	);
};
